import { ProviderLabels } from './provider-labels';

export const labels: ProviderLabels = {
  provider: 'Maxio',
  environment: {
    live: 'Live',
    test: 'Test',
  },
  coupon: {
    singular: 'Coupon',
    plural: 'Coupons',
    id: 'Code',
  },
  dashboard: {
    login: 'https://app.chargify.com/login',
  },
};
